import React from 'react';
import './AddButton.css';
import { TbCirclePlus } from 'react-icons/tb';

const AddButton = ({
    onClick,
    disabled = false,
    label,
    style,
    variant = 'primary'
}) => {
    const classNames = `add-btn ${variant} ${disabled ? 'disabled' : ''}`;

    return (
        <button
            className={classNames}
            onClick={onClick}
            disabled={disabled}
            style={style}
        >
            {label && <span className="add-btn-label">{label}</span>}
            <span className="add-btn-icon"><TbCirclePlus size={20}/></span>
        </button>
    );
};

export default AddButton;
